import { useLocation } from '@reach/router'
import React, { memo, useEffect } from 'react'

import FirstColumnHeader from './FirstColumnHeader'
import SecondColumnHeader from './SecondColumnHeader'
import { useClubContext } from '../../../contexts/ClubContext'
import { useLocalStorageContext } from '../../../contexts/LocalStorageContext'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useAnalyticsEvents } from '../../../hooks/useAnalyticsEvents'
import NotificationsBar from '../Header/components/NotificationsBar'

import './telesales-navbar.scss'

const Navbar = () => {
  const { hasClubRegister } = useStoreContext()
  const { getLocalStorage, setLocalStorage } = useLocalStorageContext()
  const { isClubClient, userInfos } = useClubContext()

  const { genericTaggingEvent } = useAnalyticsEvents()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const isEditing = queryParams.get('edit')

  useEffect(() => {
    const canOpenModal = userInfos?.email && hasClubRegister && !isClubClient
    const isNotClubPage = !window.location.pathname.includes('club')
    const hasSessionCookie =
      getLocalStorage('modal-club-session-id') === userInfos?.sessionId

    const hasSessionCookieEvent =
      getLocalStorage('login-success-session-id') === userInfos?.sessionId

    if (!hasSessionCookieEvent && userInfos?.sessionId) {
      genericTaggingEvent('login-success', {
        sessionId: userInfos?.sessionId,
        mensagem: 'usuario logado com sucesso',
      })

      setLocalStorage?.('login-success-session-id', userInfos?.sessionId ?? '')
    }

    if (isNotClubPage && canOpenModal && !hasSessionCookie) {
      setLocalStorage?.('modal-club-session-id', userInfos?.sessionId ?? '')
    }
  }, [userInfos])

  return (
    <header
      className="telesales-header telesales_navbar / grid-content-full"
      id="main-header"
    >
      <NotificationsBar />
      <div className="navbar__header">
        <section className="telesales-navbar__row / grid-content ">
          <FirstColumnHeader />
          {isEditing ? (
            <></>
          ) : (
            <p className="text">Aqui está sua lista de compras</p>
          )}
          <SecondColumnHeader />
        </section>
      </div>
    </header>
  )
}

export default memo(Navbar)
